import React, { useState } from 'react';

function BewertungDialog({ onSave, onCancel, loading }) {
  const [status, setStatus] = useState('');
  const [notiz, setNotiz] = useState('');

  const statusOptions = [
    'Verkauft',
    'Nicht Verkauft',
    'Kunde erhält Angebot',
    'Ein Überleger',
    'Termin hat nicht stattgefunden/Neue Termin',
    'Kunde hat gar kein interesse',
    'Technisch nicht umsetztzbar'
  ];

  const handleSave = () => {
    onSave({ status, notiz });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-dialog">
        <div className="modal-header">
          <h3>Terminbewertung abgeben</h3>
          <button className="close-button" onClick={onCancel}>&times;</button>
        </div>
        <div className="modal-content">
          <div className="form-group">
            <label htmlFor="bewertung-status">Bewertung*</label>
            <select
              id="bewertung-status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              required
            >
              <option value="">Bewertung auswählen</option>
              {statusOptions.map(opt => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="bewertung-notiz">Notiz*</label>
            <textarea
              id="bewertung-notiz"
              value={notiz}
              onChange={(e) => setNotiz(e.target.value)}
              rows="4"
              placeholder="Ihre Notiz..."
              required
            />
          </div>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onCancel} disabled={loading}>
            Abbrechen
          </button>
          <button
            className="confirm-button"
            onClick={handleSave}
            disabled={loading || !status || !notiz}
          >
            {loading ? 'Speichern...' : 'Bestätigen'}
          </button>
        </div>
        <style jsx>{`
            .modal-overlay {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0,0,0,0.6);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 1050;
            }
            .modal-dialog {
                background: white;
                border-radius: 8px;
                padding: 24px;
                width: 90%;
                max-width: 500px;
                box-shadow: 0 5px 15px rgba(0,0,0,0.3);
            }
            .modal-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #e2e8f0;
                padding-bottom: 12px;
                margin-bottom: 20px;
            }
            .modal-header h3 {
                margin: 0;
                font-size: 1.25rem;
                color: #2d3748;
            }
            .close-button {
                background: none;
                border: none;
                font-size: 1.75rem;
                cursor: pointer;
                color: #718096;
                line-height: 1;
            }
            .form-group {
                margin-bottom: 1rem;
            }
            .form-group label {
                display: block;
                margin-bottom: 0.5rem;
                font-weight: 600;
                color: #4a5568;
            }
            .form-group select, .form-group textarea {
                width: 100%;
                padding: 0.75rem;
                border-radius: 6px;
                border: 1px solid #cbd5e0;
                font-size: 1rem;
            }
            .form-group textarea {
                resize: vertical;
            }
            .modal-actions {
                display: flex;
                justify-content: flex-end;
                gap: 0.75rem;
                margin-top: 1.5rem;
            }
            .cancel-button, .confirm-button {
                padding: 0.6rem 1.2rem;
                border-radius: 6px;
                border: 1px solid transparent;
                cursor: pointer;
                font-weight: 600;
                font-size: 1rem;
            }
            .cancel-button {
                background: #e2e8f0;
                color: #4a5568;
                border-color: #cbd5e0;
            }
            .confirm-button {
                background: #4a6de5;
                color: white;
            }
            .confirm-button:disabled {
                background: #a0aec0;
                cursor: not-allowed;
            }
        `}</style>
      </div>
    </div>
  );
}

export default BewertungDialog; 